import columns from '../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Operator', 'operator').withTotalHeader('Total').withWidth(80),
        new TextColumn('Report ID', 'reportNo').withWidth(80),
        new TextColumn('Report', 'reportName').withWidth(300),
        new NonZeroNumberColumn('Queries', 'queries').withTotalHeader(sumTotal).withWidth(80),
      ],
    },
  ];
};
